import { render, staticRenderFns } from "./NotificationCard.vue?vue&type=template&id=25cb9498&scoped=true&"
import script from "./NotificationCard.vue?vue&type=script&lang=js&"
export * from "./NotificationCard.vue?vue&type=script&lang=js&"
import style0 from "./NotificationCard.vue?vue&type=style&index=0&id=25cb9498&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25cb9498",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25cb9498')) {
      api.createRecord('25cb9498', component.options)
    } else {
      api.reload('25cb9498', component.options)
    }
    module.hot.accept("./NotificationCard.vue?vue&type=template&id=25cb9498&scoped=true&", function () {
      api.rerender('25cb9498', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/multiplePeopleCase/components/NotificationCard.vue"
export default component.exports